import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
// import VueAnalytics from 'vue-analytics'
import VueHead from 'vue-head'
import VueGtm from 'vue-gtm'
import Home from './views/Home/Home.vue'

Vue.use(VueHead)
Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.name === from.name) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 500)
      })
    } else {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      pathToRegexpOptions: { strict: true }
    },
    {
      path: '/prodotto/:slug/',
      name: 'single-product',
      component: () => import(/* webpackChunkName: "single-product" */ './views/Product/Product.vue'),
      pathToRegexpOptions: { strict: true },
      props: route => ({ slug: route.params.slug })
    },
    {
      path: '/cosa-usare-per/:slug/',
      name: 'single-post',
      component: () => import(/* webpackChunkName: "single-post" */ './views/BlogPost/BlogPost.vue'),
      pathToRegexpOptions: { strict: true },
      props: route => ({ slug: route.params.slug })
    },
    {
      path: '/categoria/:slug/',
      name: 'single-category',
      component: () => import(/* webpackChunkName: "single-category" */ './views/Category/Category.vue'),
      pathToRegexpOptions: { strict: true },
      props: route => ({ slug: route.params.slug })
    },
    {
      path: '/tag/:slug/',
      name: 'single-tag',
      component: () => import(/* webpackChunkName: "single-tag" */ './views/Tag/Tag.vue'),
      pathToRegexpOptions: { strict: true },
      props: route => ({ slug: route.params.slug })
    },
    {
      path: '/:slug/',
      name: 'single-page',
      component: () => import(/* webpackChunkName: "pages" */ './views/Pages/Pages.vue'),
      props: route => ({ slug: route.params.slug }),
      pathToRegexpOptions: { strict: true }
    },
    {
      path: `/not-found/`,
      name: 'not-found-page',
      component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound/NotFound.vue'),
      pathToRegexpOptions: { strict: true }
    },
    {
      path: '*',
      redirect: { name: 'not-found-page' }
    }
  ]
})

// COOKIE
/*Vue.use(VueAnalytics, {
  id: 'UA-20874224-1',
  disabled: true,
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    trace: process.env.NODE_ENV === 'production',
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})*/

Vue.use(VueGtm, {
  id: 'GTM-KFM7Q6T',
  defer: false,
  enabled: true,
  debug: false,
  vueRouter: router,
  trackOnNextTick: true
})

/*
// Facebook pixel track
window.fbq('init', '1064097353792194')
*/

const asyncCondition = (fn, count = 0, errors = 500) => new Promise((resolve, reject) => {
  if (count >= errors) return reject(new Error('maximum calls'))

  window.requestAnimationFrame(async () => {
    if (fn() === true) return resolve()

    try {
      await asyncCondition(fn, count + 1)
    } catch (e) {
      reject(e)
    }
  })
})

router.afterEach(async (to, from) => {
  asyncCondition(() => typeof window.fbq === 'function')
    .then(() => window.fbq('track', 'PageView'))

  // set window.prerenderReady = false
  window.prerenderReady = false
})

export default router
